<template>
  <div>
    <div class="table-responsive">
      <paged-api-table
        v-bind:module="module" v-bind:columns="columns" v-bind:fields="fields" v-bind:filter="filter" v-bind:default-sort="defaultSort"
        v-bind:refresh-for-id="refreshForId"
        v-bind:custom-data-source="customDataSource"
        @itemUpdated="itemUpdated"
        @click="apiTableClicked"
        v-bind:per-page="perPage"></paged-api-table>
    </div>
    
    <div class="text-center card-body">
      <button v-if="addNewText" @click="addNew" class="btn btn-primary">{{addNewText}}</button>
    </div>
  </div>
</template>

<script>
  import PagedApiTable from "./PagedApiTable.vue";

  export default {
    props: {
      title: String,
      module: String,
      defaultSort: String,
      columns: Array,
      fields: Object,
      filter: Object,
      refreshForId: String,
      perPage: Number,
      customDataSource: Object,
      addNewText: String
    },
  
    data() {
      return {
        expanded: true
      };
    },
    
    methods: {
      expandPanel() {
        this.expanded = !this.expanded;
      },
      
      addNew() {
        this.$emit('add-new');
      },
      
      apiTableClicked(data) {
        this.$emit('click', data);
      },
      
      itemUpdated(data) {
        this.$emit('itemUpdated', data);
      }
    },
    
    watch: {
      refreshForId(to, from) {
        if(to && to != from) {
          this.expanded = true;
        }
      }
    },
    
    components: {
      PagedApiTable
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EmbedApiTable.vue